import { cn } from "@/lib/utils"

interface SpinnerProps {
  size?: "sm" | "md" | "lg"
  className?: string
}

/**
 * Spinner Component
 *
 * A loading spinner that can be used to indicate loading states.
 *
 * @param size - Size of the spinner: 'sm' (16px), 'md' (32px), 'lg' (48px)
 * @param className - Additional CSS classes
 *
 * @example
 * <Spinner size="md" />
 * <Spinner size="sm" className="text-blue-500" />
 */
export function Spinner({ size = "md", className }: SpinnerProps) {
  const sizeClasses = {
    sm: "h-4 w-4 border-2",
    md: "h-8 w-8 border-3",
    lg: "h-12 w-12 border-4",
  }

  return (
    <div
      className={cn("border-primary animate-spin rounded-full border-t-transparent", sizeClasses[size], className)}
      role="status"
      aria-label="Loading"
    >
      <span className="sr-only">Loading...</span>
    </div>
  )
}
